import { Table } from "@vilocnv/allsetra-core";
import { TAG_POSITION_INNER_TABLE_COLUMNS } from "app/data/constants";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useResolveAddress } from "hooks";

interface TagPositionExpendableRowCardProps {
  data: any;
}

const TagPositionExpendableRowCard: FC<TagPositionExpendableRowCardProps> = ({
  data
}) => {
  const { t } = useTranslation(["translation", "tableHeadingsTranslation"]);

  const addressLookupData = useMemo(
    () =>
      (data?.records || []).map((record: any, index: number) => ({
        ...record,
        uniqueId: `${record.date}-${record.latitude}-${record.longitude}-${index}`,
        startLatitude: record.latitude,
        startLongitude: record.longitude
      })),
    [data?.records]
  );

  const { resolvedAddresses } = useResolveAddress(addressLookupData);

  const tableColumns = useMemo(
    () => TAG_POSITION_INNER_TABLE_COLUMNS(resolvedAddresses),
    [resolvedAddresses]
  );

  return (
    <Table
      data={data.records}
      columns={tableColumns}
      noTableHead={true}
      pagination={false}
      translator={t}
    />
  );
};

export default TagPositionExpendableRowCard;
